module.exports = __webpack_public_path__ + "img/13.f8c3b155.jpg";